import callAPiBase from './base';

const devicesApi = {
  list: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/devices',
      method: 'GET',
      useToken: true,
      title: 'Devices - Get List',
      params,
    }),
  updateStatus: ({ params, id }: { params: object; id: string }) =>
    callAPiBase({
      endpoint: `/devices?id=${id}`,
      method: 'PATCH',
      useToken: true,
      title: 'Devices - Update Status',
      data: params,
    }),
};

export { devicesApi };
export default devicesApi;
